import { Component, DestroyRef, HostListener, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutService } from '../../services/layout.service';
 import { CompanyService } from '../../services/company.service'; 
import { MenuService } from '@core/services/menu.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { ConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  logo: string = 'assets/images/logo.svg'; // Ensure you have a logo path
  activeTab: string = '';
  activeSubMenu: string = '';
  roleName: string = '';
  companyId: string = '';
  isShow: boolean = false;
  isShowParkingOperations: boolean = false;
  isIconDown: boolean = false;
  isIconDownParkingOperations: boolean = false;
  hideSubMenu: boolean = false;
  activeTabs: boolean = false;
  activeRoute : string = '';
  menuObj;
  _isSidebarOpen;
  private actions = {
    "log": () => this.logout(),
    "h_&_s": () => this.navigateToSupport(),
  };
  @Input() set isSidebarOpenClosed(value: any) {    
    this._isSidebarOpen = value
  }

  menuNames: any = {
    "ParkingManager": ["db", "b", "pl", "mp", "f", "m", "r", "h", "l","mcp","mobf","modm"],
    "ParkingOwner": ["db", "b", "pl", "mp", "cp", "f", "m", "r", "h", "l", "mu","mcp","mobf"],
    "Driver": ["p", "d", "l", "o", "pp", "ts", "H", "hs", "df"],
    "SuperAdmin": ['as', 'ps', "sab", "om", "txn", "sapl", "cd", "dl",'saf']
  };
  menuData: any[];
  actionPermissions
  com
  isGuestUser: string;
  isSmallScreen:boolean = false;
  isSidebarOpen :boolean = false
  collapsed : boolean
  version;
  constructor( 
    private readonly router: Router,
    private readonly layoutService: LayoutService,
    private readonly companyService: CompanyService,
    private readonly menuService: MenuService,
    private readonly renderer: Renderer2,
    private readonly encryptStorage: EncryptionStorageService,
    private readonly configService: ConfigService
    ) {
    }

ngOnInit() {
    this.layoutService.isSmallScreen$.subscribe((isSmall: boolean) => {
      this.isSmallScreen = isSmall;
      this.isSidebarOpen = this.layoutService.isSidebarOpen;
      if(this.isSidebarOpen){
      this.closeAllSubmenus();
      }
    });
    this.router.events.subscribe(() => {
      this.renderer.addClass(document.body, 'logged-in');
    });
    this.isGuestUser = this.encryptStorage.getItem('isGuestUser');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
      }
    });
    this.activeRoute = this.router.url;
    this.isRouteActive(this.activeRoute);
      
    this.roleName = this.encryptStorage.getItem('roleName') || '';
    const roleVersionMap = {
      [USER_ROLES.DRIVER]: this.configService.get('versions').driver,
      [USER_ROLES.GROUP_USER]: this.configService.get('versions').groupOperator
    };
    
    this.version = CommonFunctions.isAdminOrOwnerRole(this.roleName) 
      ? this.configService.get('versions').adminRoles
      : roleVersionMap[this.roleName] || this.version;
    if (!this.layoutService.isSidebarOpen) {
      this.hideSubMenu = true;
    }
      const isGuestBookingRoute = (
      this.activeRoute.includes('guest/booking') ||
      this.activeRoute.includes('guest/transflow-booking') ||
      this.activeRoute.includes('guest/transflow-create-booking')
    );

    if (!this.isGuestUser && !isGuestBookingRoute) {
      this.menuService.getRoleBaseMenuAndActionPermission()
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (menuResponse: any) => {
        this.menuService.setMenuData(menuResponse);
        this.encryptStorage.setItem('menuData', JSON.stringify(menuResponse));
        }
      });
    }
  
    if (this.roleName === USER_ROLES.SUPER_ADMIN) {
      this.companyId = this.encryptStorage.getItem('companyId');
      this.companyService.getCompanyId()
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe(id => {
        if (id !== '0' && id !== '') {
          this.companyId = id;
          this.getMenuData();
        } else {
          this.companyId = this.encryptStorage.getItem('companyId');
        }
      });
    } else {
      this.getMenuData();
    }
  }

@HostListener('mouseenter')
  onHover() {
    if (this.isSidebarOpen) {
      this.collapsed = true;
      this.layoutService.setSidebarHovered(true);
      this.closeAllSubmenus();
    }
  }

  @HostListener('mouseleave')
  onLeave() {
    if (this.isSidebarOpen) {
      this.collapsed = false;
      this.layoutService.setSidebarHovered(false);
      this.closeAllSubmenus();
   }
  }
  getMenuData() {
    this.menuService.getMenuData()
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe(data => {
        this.menuObj = this.generateDynamicMenu(data, this.companyId);
    });
  }

generateDynamicMenu(menuTemplate: any[], companyId: string): any[] {
    const placeholderRegex = /{companyId}/g;
    return menuTemplate.map(menu => {
      const replaced = this.replacePlaceholders(menu, companyId, placeholderRegex);
 
      if (typeof replaced.url === 'string' && replaced.url.includes('/super-admin/bookings/')) {
        const hasTab = replaced.url.includes('tab=');
        if (!hasTab) {
          const separator = replaced.url.includes('?') ? '&' : '?';
          return {
            ...replaced,
            url: `${replaced.url}${separator}tab=0`
          };
        }
      }
 
      return replaced;
    });
  }

  replacePlaceholders(menuItem: any, companyId: string, regex: RegExp): any {
    const newMenuItem = { ...menuItem };
    const createImageWithShortName = (shortName: string) => {
      return `assets/images/sidebar_svg/${shortName}.svg`;
    };
    if (newMenuItem.actions) {
      newMenuItem.actions = newMenuItem.actions.map(action => ({
        ...action,
        path: action.path ?(action.path.includes('{companyId}') ? action.path.replace(regex, companyId) : action.path) : ''
      }));
    }
    newMenuItem.menuImage = createImageWithShortName(newMenuItem.shortName);
    const activeRoute = this.activeRoute;
    if (((activeRoute.includes('super-admin/bookings') || (activeRoute.includes('super-admin/group-booking-list') )) && newMenuItem.shortName === 'park_op_sa') || activeRoute.includes('super-admin/invoice') && newMenuItem.shortName === 'inv_sa') {
      newMenuItem.isShow = true;
    }else {
      newMenuItem.isShow = false;
    }
  
    if (newMenuItem.submenu) {
      newMenuItem.submenu = newMenuItem.submenu.map(submenu => ({
        ...submenu,
        menuImage: createImageWithShortName(submenu.shortName),
        actions: submenu.actions ? submenu.actions.map(action => ({
          ...action,
          path: action.path ? (action.path.includes('{companyId}') ? action.path.replace(regex, companyId) : action.path) : '',
        })) : [],
      }));
    }
    return newMenuItem;
  }
  isRouteActive(route: string): boolean {
    return this.activeRoute.includes(route);
    }
    
  navigate(route: string, companyId: string = '') {
    if (companyId) {
      this.router.navigate([route, companyId]);
    } else {
      this.router.navigate([route]);
    }
  }

  shouldOpenInNewTab(menuName: string): boolean {
    const newTabMenus = ['trm_of_srv', 'Priv_poli'];
    return newTabMenus.includes(menuName);
  }

  setActive(tab: string): void {
    this.activeTab = tab;
  }

  urlOpenInNewTab(url: string) {
    window.open(url, '_blank');
  }
  
  setActiveSubMenu(subMenu: string): void {
    this.activeSubMenu = subMenu;
  }

  logout(): void {
    if(this.isSmallScreen) {
      this.layoutService.toggleSidebar();
    }
    this.router.events.subscribe(() => {
      this.renderer.removeClass(document.body, 'logged-in');
    });
    localStorage.clear();
    this.router.navigateByUrl("login");
  }

  isAllowed(menuItem: string) {
    return this.menuNames[this.roleName]?.includes(menuItem) || false;
  }

  toggleSideBar(menu) {
    menu.isShow = !menu.isShow;
  }

  closeAllSubmenus() {
    this.menuObj.forEach(menu => menu.isShow = false);
  }

  toggleSideBarParkingOperations() {
    this.isShowParkingOperations = !this.isShowParkingOperations;
    this.isIconDownParkingOperations = !this.isIconDownParkingOperations;
  }

  handleRouteLink(routeUrl: string, companyId: string) {
    this.activeTab = '';
    this.navigate(routeUrl, companyId);
  }

  navigateToDriverBooking() {
    this.router.navigate(['/driver/booking']);
  }

  navigateToStatics() {
    this.router.navigate(['/super-admin/statics']);
  }

  isLinkActive(url: string): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl = queryParamsIndex === -1 ? this.router.url : this.router.url.slice(0, queryParamsIndex);
    return baseUrl === url;
  }

  navigateToBooking() {
    this.router.navigate(['/super-admin/booking/' + this.companyId]);
  }

  navigateToSupport() {
    window.location.href = 'mailto:support@trucklots.com';
  }
  
  handleClickEvent(menuShortName: string) {
    const action = this.actions[menuShortName];
    if (action) {
      action();
    }
  }
  removeDriverId(){
    localStorage.removeItem('driverId')
  }
  closeSideTab() {
      if (this.isSmallScreen) {
        this.layoutService.toggleSidebar();
        this.collapsed = false;
      }
  };

  closeSbmenu(_submenu){
    if(this.isSmallScreen){
      this.layoutService.toggleSidebar();
      this.collapsed = false;
    }
  }
}
